// Source coolicons.cool
import React from "react";
import type { IconProps } from "./props";

const SystemBarLeft = ({ size = "15", fill = "currentColor" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 20L9 4"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 19V5C20 4.44772 19.5523 4 19 4L5 4C4.44772 4 4 4.44772 4 5L4 19C4 19.5523 4.44771 20 5 20H19C19.5523 20 20 19.5523 20 19Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SystemBarLeft;
